import { type Observable, observable } from "@legendapp/state";
import { ObservablePersistLocalStorage } from "@legendapp/state/persist-plugins/local-storage";
import { syncObservable } from "@legendapp/state/sync";
import { type SharedStore, sharedStore } from "@simble/shared/store";
import type { LocalStore } from "./local-store.d";

export const localStore = observable<LocalStore>({
  userName: "",
  partnerId: null,
  fio: undefined,
  phoneNum: undefined,
  email: undefined,
  experienceStartDate: undefined,
  passport: undefined,
  noSurname: undefined,
  grz: "",
  passportDate: undefined,
});

const initialStore = {
  ...sharedStore.peek(),
  ...localStore.peek(),
};

export const store: Observable<SharedStore & LocalStore> = observable(initialStore);

export const resetStore = () => {
  const resetData = {
    ...sharedStore.peek(),
    ...localStore.peek(),
  };
  store.assign(resetData);
};

syncObservable(store, {
  persist: {
    name: "finuslugi-store",
    plugin: ObservablePersistLocalStorage,
  },
});
